<template>
    <div class="page-dialog">
        <div class="logo">
            <img alt="WTX logo" src="../assets/wtx-logo.png" width="150" style="margin-top: 16px;">
        </div>
        <div>
            <h1 style="text-align: center; margin-bottom: 50px; margin-top: 100px;">
                微特芯物联网控制平台
            </h1>
        </div>
        <div class="dialog">
            <div class="title">用户登录</div>
            <Form :model="user" :ref="refName" :rules="ruleValidate" :label-width="70" style="margin: 24px 16px 0 16px">
                <FormItem label="用户名" prop="username">
                    <Input v-model="user.username" placeholder="请输入用户名" />
                </FormItem>
                <FormItem label="密码" prop="password">
                    <Input type="password" v-model="user.password" placeholder="请输入密码" />
                </FormItem>
                <FormItem style="text-align: right">
                    <Button type="primary" @click="login">登录</Button>
                </FormItem>
            </Form>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import resource from 'vue-resource'

    Vue.use(resource);

    export default {
        components: {
        },
        data() {
            const validateUsername = (rule, value, callback) => {
                //不允许为空
                if (!value || value.match(/^\s*$/)) {
                    callback(new Error('请输入用户名'));
                } else {
                    callback();
                }
            };
            const validatePassword = (rule, value, callback) => {
                //不允许为空
                if (!value || value.match(/^\s*$/)) {
                    callback(new Error('请输入密码'));
                } else {
                    callback();
                }
            };
            return {
                refName: 'loginForm',
                user: null,
                ruleValidate: {
                    username: [
                        { validator: validateUsername, trigger: 'blur' }
                    ],
                    password: [
                        { validator: validatePassword, trigger: 'blur'  }
                    ]
                }
            }
        },
        props: {
        },
        created() {
            this.user = this.$coreData.user;
        },
        methods: {
            login() {
                // window.console.log(this.user);
                this.$refs[this.refName].validate(valid => {
                    if (valid) {
                        this.$coreData.checkUser(this.user, (status, errMsg) => {
                            if (status === 'success') {
                                this.$Message.success('登录成功');
                                this.$emit('login-success');
                            } else {
                                this.$Message.error(errMsg);
                                // window.console.log(errMsg);
                            }
                        });
                    }
                });
            }
        }
    }
</script>

<style>
    .page-dialog {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 500px;
    }

    .dialog {
        width: 80%;
        border: 1px solid rgb(232, 234, 236);
        border-radius: 8px;
    }

    .title {
        height: 38px;
        line-height: 38px;
        text-align: center;
        background-color: rgb(247, 247, 247);
    }

    .logo {
        width: 100%;
        text-align: left;
        margin-left: 32px;
    }

    /*屏幕分辨率较小时*/
    @media screen and (max-device-width: 576px) {
        .page-dialog {
            width: 100% !important;
        }
    }
</style>